<template>
  <v-card class="ma-3 pa-5" v-if="activeProbe">
    <h3>Sensors</h3>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Alias
          </th>
          <th width="15%" class="text-center">
            Active
          </th>
          <th width="15%" class="text-center">
            Error
          </th>
          <th width="15%" class="text-left">
            Depth(cm)
          </th>
          <th width="15%" class="text-left">
            Sensor type
          </th>
          <th class="text-right" width="5%"/>
          <th class="text-right" width="5%"/>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="sensor in activeProbe.sensors"
            :key="`sensor_${sensor.id}`"
        >
          <td>{{ sensor.alias }}</td>
          <td class="text-center">
            <v-select :items="statusOptions" v-model="sensor.is_active" item-text="label" item-value="value"/>
          </td>
          <td class="text-center">
            <v-tooltip v-if="sensor.has_error" bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="red">mdi-alert-circle-outline</v-icon>
              </template>
              <span>{{ sensor.error_type ? sensor.error_type : 'error' }}</span>
            </v-tooltip>
            <v-icon v-else>mdi-minus</v-icon>
          </td>
          <td>
            <v-text-field v-model="sensor.depth" type="number"/>
          </td>
          <td>
            <v-select v-model="sensor.sensor_type" :items="sensorTypeOptions" item-text="label" item-value="value"/>
          </td>
          <td class="text-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                    src="../../../../vue-public/src/assets/img/Info.svg"
                    class="tip icon-info-map icon-move"
                >mdi-information-outline</v-icon>
              </template>
              <span v-for="kv in Object.entries(sensor.sensor_variable_avg || {})" :key="kv[0]">{{kv[0]}}: {{kv[1]}} <br></span>
            </v-tooltip>
          </td>
          <td class="text-right">
            <v-btn @click="handleUpdateSensorClick(sensor)" small color="primary">Save</v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "StationSensorsCard",
  data() {
    return {
      sensorTypeOptions: [
        {label: '-', value: null},
        {label: 'Air', value: 'air'},
        {label: 'Ground', value: 'ground'},
      ],
      statusOptions: [
        {'label': 'Active', value: true},
        {'label': 'Inactive', value: false}
      ]
    }
  },
  computed: {
    ...mapState('probe', ['activeProbe']),
  },
  methods: {
    ...mapActions('probe', ['updateSensor']),
    async handleUpdateSensorClick(sensor) {
      await this.updateSensor(sensor)
    }
  }
}
</script>

<style scoped>
.flex-td {
  /*display: flex;
  flex-direction: row;*/
}
.icon-move {
  padding-right: 10px;
}
</style>